import { JoinRoomDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
export const showJoinRoomDialog = mountDialogUIReactComponent(JoinRoomDialog);
